

































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { convertToHtmlHelper, getLanguagesHelper, isEmptyObject, onScroller } from '@/heplers';
import { Getter, Mutation, State } from 'vuex-class';
import ArticleRating from '../../ui/ArticleRating.vue';
import StatusBadge from '../../ui/StatusBadge.vue';
import ImgFullscreen from '../../ui/ImgFullscreen.vue';
import LanguageInfo from './LanguageInfo.vue';
import CodeExampleBody from '@/components/docs-main/code-rails-view/CodeExampleBody.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames, StoreMutations } from '@/templates/DataNames';
import { TutorialType } from '@/templates/Tutorial';
import Badges from '@/components/docs-main/reference-pages/Badges.vue';
import { BadgesType } from '@/templates/NewRoutes';
import { CodeExampleObservers } from '@/heplers/codeExampleObservers';
import CopyUrlButton from '@/components/ui/buttons/CopyUrlButton.vue';
import {
  convertStringToAnchorIdHelper,
  convertStringToAnchorIdNoHashHelper,
  convertToAnchorIdHelper,
  getLastNameHelper,
} from '@/heplers/stringHelpers';
import Prism from 'prismjs';

@Component({
  components: {
    Badges,
    ArticleRating,
    StatusBadge,
    LanguageInfo,
    CodeExampleBody,
    CopyUrlButton,
    ImgFullscreen,
  },
  filters: {
    convertToAnchorId: convertToAnchorIdHelper,
    convertStringToAnchorId: convertStringToAnchorIdHelper,
    convertStringToAnchorIdNoHash: convertStringToAnchorIdNoHashHelper,
  },
})
export default class Tutorial extends Vue {
  @Getter('getContent') data: TutorialType;
  @State('pageRendered') pageRendered: boolean;
  @Mutation(StoreMutations.SET_CURRENT_ANCHOR) setAnchor: (anchor: string) => void;
  convertToHtml = convertToHtmlHelper;
  private languages: string[] = [];

  get attributesExist() {
    return this.data.attributes && !Array.isArray(this.data.attributes);
  }

  /**
   * Собираем объект для alert блоков
   */
  get statusBadges() {
    if (!this.data.attributes) return {};

    const allowedBadgeNames: BadgesType[] = Object.values(BadgesType);

    const filter = (attributes: any, allowedBadgeNames: any) =>
      allowedBadgeNames.reduce((acc: any, name: any) => {
        if (attributes[name] && typeof attributes[name] === 'string') {
          acc[name] = attributes[name];
        }
        return acc;
      }, {});

    return filter(this.data.attributes, allowedBadgeNames);
  }

  @Watch('pageRendered')
  onPageRenderedChanged(val: boolean) {
    if (val) {
      this.languages = this.getLanguages(this.data);
      CodeExampleObservers.bindObservers();
      this.checkAnchor();
    }
  }

  /**
   * @description - отключаем слушатели, загружаем контент до якоря, скроллим к нему,и включаем слушателей
   * @param fqdn: string - fqdn якоря, к которому нужно перейти
   */
  scrollToAnchor(fqdn: string) {
    const article = document.getElementById(this.$route.hash.replace('#', ''));
    if (article) {
      onScroller(this.$route.hash.replace('#', ''));
    } else {
      const hash = getLastNameHelper(fqdn);
      this.setAnchor(hash);
      this.loadContentUntilAnchor();

      //Ждем пока подгрузятся данные
      this.$nextTick(() => {
        onScroller('#' + hash);
      });
    }
  }

  private loadContentUntilAnchor() {
    let orderData: any = this.data;
    if (isEmptyObject(orderData)) return;
  }

  checkAnchor() {
    const routeFqdn = `${this.$route.meta.fqdn}.${location.hash.replace('#', '')}`;
    this.scrollToAnchor(routeFqdn);
  }

  public checkTargetLink(link: string) {
    return link.includes('http') ? '_blank' : '_self';
  }

  public goToCodeExamples(dataInfo: any): void {
    let anchorId = dataInfo.uniqId;
    CodeExampleObservers.setCurrentCodeButton(anchorId);
    GlobalBus.emit(GlobalBusNames.CHANGEEXAMPLE, anchorId);
  }

  showCodeExample(obj: any) {
    return obj.kind === 'content_source' && obj.title;
  }

  private getLanguages(tutorial: TutorialType) {
    return getLanguagesHelper(tutorial);
  }
  mounted() {
    Prism.highlightAll();
  }
}
